import React, { useEffect, useState } from 'react'

import Loader from 'uiKit/loaders/loader'
import { DatasetInfo } from './DatasetInfo'
import { DescriptionDatasetTables } from './DescriptionDatasetTables'
import { useDatasets } from '../hooks/useDatasets'
import { Dataset } from '../../../api/generated'
import { DatasetTabs } from './DatasetTabs'

export const DescriptionDatasets = () => {
  const { data, loading } = useDatasets()
  const [selectedDataset, setSelectedDataset] = useState<Dataset | null>(null)

  useEffect(() => {
    if (!selectedDataset && data?.length && data[0]) {
      setSelectedDataset(data[0])
      // setSelectedDataset(data[0] as GetDatasetVersionsResponse['datasets'])
    }
  }, [selectedDataset, data])

  if (!selectedDataset && loading) {
    return <Loader />
  }

  const title = selectedDataset?.datasetName
  const text = selectedDataset?.activeVersionDescription?.datasetDescription
  const updatedAt = selectedDataset?.activeVersionDescription?.updatedAt

  const tabs = (data || [])?.map(item => ({
    label: item?.datasetName,
    value: item?.activeVersionDescription?.datasetId,
  }))

  const handleChange = (index: number) => {
    const item = data[index] || data[0]

    if (item) setSelectedDataset(item as Dataset)
  }

  return (
    <div>
      <DatasetTabs tabs={tabs} activeTab={title} updatedAt={updatedAt} onChange={handleChange} />

      <DatasetInfo title={title} text={text} />

      <DescriptionDatasetTables datasetId={selectedDataset?.activeVersionDescription?.datasetId} />
    </div>
  )
}
